import React, { useState } from 'react';
import { Button, Container, Modal, ModalBody, ModalFooter } from 'reactstrap';
import Header from '../components/Header';
import { SERVER_IP, createPaymentAttempt } from '../config/apiConfig';
import axios from 'axios';
import moment from 'moment';
import cvv from '../assets/cvv.png';
import Imagen4 from '../assets/Imagen4.png';
import Imagen5 from '../assets/Imagen5.png';
import Imagen6 from '../assets/Imagen6.png';
import Imagen11 from '../assets/Imagen11.png';
import Imagen13 from '../assets/Imagen13.png';
import Imagen14 from '../assets/Imagen14.png';
import Imagen15 from '../assets/Imagen15.png';
import Imagen17 from '../assets/Imagen17.png';
import Imagen18 from '../assets/Imagen18.png';

const MP_KEY = process.env.REACT_APP_MP_KEY;

const Payment = (props) => {
  window.Mercadopago.setPublishableKey(MP_KEY);
  // window.Mercadopago.getIdentificationTypes();

  const {
    appointmentIds,
    appointmentDate,
    appointmentTime,
    appointmentDepartment,
    slotAmount,
    email,
    examAppointment = false,
  } = props.location.state;
  const [method, setMethod] = useState('credit_card');
  const [docType, setDocType] = useState(1);
  const [rut, setRut] = useState({ checked: false, values: {} });

  const guessPaymentMethod = (event) => {
    event.persist();
    let cardnumber = event.target.value;
    if (cardnumber.length >= 6) {
      let bin = cardnumber.substring(0, 6);
      window.Mercadopago.getPaymentMethod(
        {
          bin: bin,
        },
        setPaymentMethod
      );
    }
  };

  function setPaymentMethod(status, response) {
    if (status === 200) {
      let paymentMethod = response[0];
      document.getElementById('paymentMethodId').value = paymentMethod.id;
      // getIssuers(paymentMethod.id);
    } else {
      console.error(response);
      // alert(`payment method info error: ${Object.values(response)[0]}`);
    }
  }

  function getIssuers(paymentMethodId) {
    window.Mercadopago.getIssuers(paymentMethodId, setIssuers);
  }

  function setIssuers(status, response) {
    if (status === 200) {
      let issuerSelect = document.getElementById('issuer');
      // issuerSelect.innerHTML = '';
      response.forEach((issuer) => {
        let opt = document.createElement('option');
        opt.text = issuer.name;
        opt.value = issuer.id;
        issuerSelect.appendChild(opt);
      });
      // getInstallments(
      //   document.getElementById('paymentMethodId').value,
      //   document.getElementById('transactionAmount').value,
      //   issuerSelect.value
      // );
    } else {
      console.error(response);
      alert(`issuers method info error: ${Object.values(response)[0]}`);
    }
  }

  //   function setIssuers(status, response) {
  //     if (status == 200) {
  //         let issuerSelect = document.getElementById('issuer');
  //         response.forEach( issuer => {
  //             let opt = document.createElement('option');
  //             opt.text = issuer.name;
  //             opt.value = issuer.id;
  //             issuerSelect.appendChild(opt);
  //         });

  //         getInstallments(
  //             document.getElementById('paymentMethodId').value,
  //             document.getElementById('transactionAmount').value,
  //             issuerSelect.value
  //         );
  //     } else {
  //         alert(`issuers method info error: ${response}`);
  //     }
  //  }

  function getInstallments(paymentMethodId, transactionAmount, issuerId) {
    window.Mercadopago.getInstallments(
      {
        payment_method_id: paymentMethodId,
        amount: parseFloat(transactionAmount),
        issuer_id: parseInt(issuerId),
      },
      setInstallments
    );
  }

  function setInstallments(status, response) {
    if (status === 200) {
      document.getElementById('installments').options.length = 0;
      response[0].payer_costs.forEach((payerCost) => {
        let opt = document.createElement('option');
        opt.text = payerCost.recommended_message;
        opt.value = payerCost.installments;
        document.getElementById('installments').appendChild(opt);
      });
    } else {
      console.error(response);
      alert(`installments method info error: ${Object.values(response)[0]}`);
    }
  }

  let doSubmit = false;
  function getCardToken(event) {
    event.preventDefault();
    if (!doSubmit) {
      let $form = document.getElementById('paymentForm');
      window.Mercadopago.createToken($form, setCardTokenAndPay);
      return false;
    }
  }

  const [modal, setModal] = useState(false);
  const [successfulPayment, setSuccessfulPayment] = useState(false);
  const toggle = () => {
    setModal(!modal);
    setSuccessfulPayment(false);
  };

  function setCardTokenAndPay(status, response) {
    if (status === 200 || status === 201) {
      let form = document.getElementById('paymentForm');
      let card = document.createElement('input');
      card.setAttribute('name', 'token');
      card.setAttribute('type', 'hidden');
      card.setAttribute('value', response.id);
      form.appendChild(card);
      doSubmit = true;
      const data = new FormData(form);
      examAppointment
        ? data.append('exam_appointment_id', appointmentIds[0])
        : data.append('appointment_ids', appointmentIds);
      axios
        .post(`${SERVER_IP}/appointments/payment/`, data)
        .then((res) => {
          if (res.data === 'approved') {
            setSuccessfulPayment(true);
            setModal(true);
          } else {
            setSuccessfulPayment(false);
            setModal(true);
          }
        })
        .catch((err) => {
          doSubmit = false;
          alert(JSON.stringify(err.response.data, null, 4));
        });
    } else {
      doSubmit = false;
      console.error(JSON.stringify(response, null, 4));
      // alert('Verify filled data!\n' + JSON.stringify(response, null, 4));
      setSuccessfulPayment(false);
      setModal(true);
    }
  }

  const submit = (event) => {
    event.preventDefault();

    //find the email to create the payment attempt
    const email = document.getElementById('email').value;
    createPaymentAttempt(email);

    //do the payment
    if (method === 'credit_card') {
      getCardToken(event);
    } else {
      let form = document.getElementById('paymentForm');
      const data = new FormData(form);
      examAppointment
        ? data.append('exam_appointment_id', appointmentIds[0])
        : data.append('appointment_ids', appointmentIds);
      axios
        .post(`${SERVER_IP}/appointments/payment/`, data)
        .then((res) => {
          if (res.data === 'pending') {
            setSuccessfulPayment(true);
            setModal(true);
          } else {
            setSuccessfulPayment(false);
            setModal(true);
          }
        })
        .catch((err) => alert(JSON.stringify(err.response.data, null, 4)));
    }
  };

  let totalAmount = 0;
  totalAmount += +slotAmount * appointmentIds.length;
  totalAmount += +appointmentDepartment.amount;
  if (appointmentIds.length > 1) {
    totalAmount +=
      +appointmentDepartment.promotional_amount * (appointmentIds.length - 1);
  }

  return (
    <div className="payment">
      <Modal isOpen={modal} toggle={toggle}>
        <ModalBody>
          {successfulPayment ? (
            <div>
              Pago confirmado.
              <br />
              <br />
              Su prueba SARS-CoV-2 ha sido agendada con éxito para el
              <b className="text-secondary">
                {' '}
                {moment(appointmentDate, 'L').format('dddd, DD MMMM YYYY')}.
                {!examAppointment && 'Turno:' + { appointmentTime }}.
              </b>
            </div>
          ) : (
            'Pago rechazado, revisa los datos proporcionados.'
          )}
        </ModalBody>
        <ModalFooter>
          {successfulPayment ? (
            <Button
              color="primary"
              onClick={() => {
                toggle();
                props.history.push('/');
              }}
            >
              {' '}
              Aceptar{' '}
            </Button>
          ) : (
            <Button
              color="primary"
              onClick={() => {
                toggle();
              }}
            >
              {' '}
              Reintentar{' '}
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <Header history={props.history} />
      <h5 className="text-center mb-3 text-secondary">Facturación</h5>
      <Container className="d-flex flex-column align-items-center">
        <div id="message-container" className="col-container no-shadow pt-2">
          <p>
            Cita agendada
            <br />
            <b id="appointment-date">
              {examAppointment
                ? moment(appointmentDate).format('DD-MM-YYYY HH:mm')
                : moment(appointmentDate, 'L').format('dddd, DD MMMM YYYY')}
              .
            </b>{' '}
            {!examAppointment && 'Turno:'}
            <b>{!examAppointment && appointmentTime}</b>.
          </p>
        </div>
        <div id="message-container" className="col-container mb-4">
          <b>Detalle de pago</b>
          <br />
          <br />
          <div className="d-flex justify-content-between">
            <p>
              <span>Costo de la prueba</span>
              <br />
              <span className="taxes-tag">IVA + TP incl.</span>
            </p>
            <p>
              {appointmentIds.length > 1 && (
                <b className="mr-2">{appointmentIds.length}x</b>
              )}
              <span>${slotAmount}</span>
            </p>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <p>
              <span>Toma de muestra en {appointmentDepartment.name}</span>
              <br />
              <span className="taxes-tag">IVA incl.</span>
            </p>
            <p>
              <span>${appointmentDepartment.amount}</span>
            </p>
          </div>
          {
            // if there are more than one appointments we have to show the promotional department cost
            appointmentIds.length > 1 && (
              <div className="d-flex justify-content-between mt-3">
                <p>
                  <span>Toma de muestra en {appointmentDepartment.name}</span>
                  <br />
                  <span className="taxes-tag">IVA incl.</span>
                </p>
                <p>
                  {appointmentIds.length > 2 && (
                    <b className="mr-2">{appointmentIds.length - 1}x</b>
                  )}
                  <span>${appointmentDepartment.promotional_amount}</span>
                </p>
              </div>
            )
          }
          <hr className="border-primary" />
          <div className="d-flex justify-content-between mt-3">
            <p>
              <span className="text-secondary">Total a pagar</span>
              <br />
              <span className="taxes-tag">
                Costo total de prueba + muestra en {appointmentDepartment.name}{' '}
                + IVA + TP
              </span>
            </p>

            <b className="h3 text-secondary">${totalAmount}</b>
          </div>
        </div>
        <form
          id="paymentForm"
          className="d-flex flex-column align-items-center w-100"
          onSubmit={submit}
        >
          <div className="col-container">
            <div>
              <input
                id="email"
                name="email"
                type="email"
                placeHolder="Email"
                defaultValue={email || ''}
              />
            </div>

            <div id="doc">
              <select
                id="docType"
                name="docType"
                data-checkout="docType"
                type="select"
                required
                onChange={(e) => setDocType(e.target.value)}
              >
                <option value="" disabled selected>
                  Tipo de documento
                </option>

                <option value="CI">CI</option>
                <option value="Otro">Otro</option>
              </select>

              <input
                id="docNumber"
                name="docNumber"
                data-checkout="docNumber"
                type={docType == 'CI' ? 'number' : 'text'}
                placeHolder="Núm. documento"
                required
              />
            </div>
            <select
              id="paymentMethod"
              name="paymentMethod"
              onChange={(e) => setMethod(e.target.value)}
            >
              <option selected value="credit_card">
                Tarjeta de Débito o Crédito
              </option>
              <option value="abitab">Abitab</option>
              <option value="redpagos">Redpagos</option>
            </select>
            {method === 'credit_card' && (
              <div>
                <small className="font-italic font-weight-light text-secondary">
                  * No se aceptan tarjetas de crédito internacionales por el
                  momento
                </small>
                <input
                  onChange={guessPaymentMethod}
                  id="cardNumber"
                  type="number"
                  data-checkout="cardNumber"
                  placeHolder="Número de la tarjeta"
                />
                <input
                  id="cardholderName"
                  data-checkout="cardholderName"
                  type="text"
                  placeHolder="Nombre y apellido"
                />
                <div id="expire-date">
                  <select
                    required
                    type="text"
                    placeHolder="Mes de vto"
                    id="cardExpirationMonth"
                    data-checkout="cardExpirationMonth"
                  >
                    <option disabled selected>
                      Mes de vto
                    </option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="8">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  <input
                    type="number"
                    placeHolder="Año de vto"
                    id="cardExpirationYear"
                    data-checkout="cardExpirationYear"
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center w-100 my-4">
                  <input
                    id="securityCode"
                    data-checkout="securityCode"
                    type="number"
                    placeHolder="Código de seguridad"
                  />
                  <img src={cvv} alt="cvv" className="cvv" />
                  {/* <select
                    type='text'
                    id='installments'
                    name='installments'
                  >
                    <option value='' disabled selected>Cuotas</option>
                  </select> */}
                </div>
                <div id="issuerInput" className="d-none">
                  <label htmlFor="issuer">Banco emisor</label>
                  <br />
                  <select id="issuer" name="issuer" data-checkout="issuer" />
                  <input
                    type="hidden"
                    name="transactionAmount"
                    id="transactionAmount"
                    // value={0} the transactionAmount is calculated by the backend based on the appointments we send
                  />
                  <input
                    type="hidden"
                    name="paymentMethodId"
                    id="paymentMethodId"
                  />
                  <input type="hidden" name="description" id="description" />
                </div>
              </div>
            )}
            <span className="text">Factura con RUT</span>
            <div class="Container">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input radio-payment"
                  type="radio"
                  name="radioRut"
                  value={true}
                  checked={rut.checked === true}
                  onChange={() =>
                    setRut((prevRut) => ({ ...prevRut, checked: true }))
                  }
                />
                <label class="form-check-label">Si</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input radio-payment"
                  type="radio"
                  name="radioRut"
                  value={false}
                  checked={rut.checked === false}
                  onChange={() =>
                    setRut((prevRut) => ({ ...prevRut, checked: false }))
                  }
                />
                <label class="form-check-label">No</label>
              </div>
            </div>
            {rut.checked === true && (
              <div>
                <br />
                <input
                  id="rutNumber"
                  name="rut_number"
                  type="number"
                  placeHolder="Número de RUT"
                  onChange={(e) =>
                    setRut((prevRut) => ({
                      ...prevRut,
                      values: {
                        ...prevRut.values,
                        [e.target.name]: e.target.value,
                      },
                    }))
                  }
                />
                <input
                  id="razonSocial"
                  name="business_name"
                  type="text"
                  placeHolder="Razón social"
                  onChange={(e) =>
                    setRut((prevRut) => ({
                      ...prevRut,
                      values: {
                        ...prevRut.values,
                        [e.target.name]: e.target.value,
                      },
                    }))
                  }
                />
                <input
                  id="address"
                  name="address"
                  type="text"
                  placeHolder="Dirección fiscal"
                  onChange={(e) =>
                    setRut((prevRut) => ({
                      ...prevRut,
                      values: {
                        ...prevRut.values,
                        [e.target.name]: e.target.value,
                      },
                    }))
                  }
                />
              </div>
            )}

            {(method === 'abitab' || method === 'redpagos') && (
              <div>
                <p className="mt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-exclamation-triangle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                  </svg>
                  Para la opción de pago seleccionada le solicitamos que realice
                  el pago al menos 2 horas antes del comienzo de su turno para
                  hisoparse.
                </p>
              </div>
            )}
            <p className="mt-5">Medios de Pagos Disponibles</p>
            <div className="d-flex flex-wrap justify-content-around align-items-center mb-3">
              <img src={Imagen11} alt="available-methods-4" />
              <img src={Imagen5} alt="available-methods-2" />
              <img src={Imagen4} alt="available-methods-1" />
              <img src={Imagen6} alt="available-methods-3" />
              <img src={Imagen15} alt="available-methods-7" />
              <img src={Imagen18} alt="available-methods-9" />
              <img src={Imagen13} alt="available-methods-5" />
              <img src={Imagen17} alt="available-methods-8" />
              <img src={Imagen14} alt="available-methods-6" />
            </div>
          </div>
          <div className="d-flex justify-content-end w-45">
            <Button type="submit">PAGAR</Button>
          </div>
        </form>
      </Container>
    </div>
  );
};

export default Payment;
